import { Controller } from "@hotwired/stimulus"

let index
let articles

const setup = async () => new Promise(resolve => {
  if (index) {
    resolve()
  } else {
    require(["lunr"], async (lunr) => {
      const data = await fetch("/search.json").then(res => res.json())
      index = lunr.Index.load(data.index)
      articles = data.articles
      resolve()
    })
  }
})

const search = (keywords) => {
  let results = []

  if (index) {
    try {
      results = index.search(keywords)
    } catch (error) {
      // eslint-disable-line no-empty
    }
  }

  return results.map(result => articles.find(a => a.id === result.ref))
}

export default class extends Controller {
  static targets = ["title", "icon", "results"]
  static values = { keywords: String, limit: Number, title: String }

  async connect () {
    await setup()

    if (this.keywordsValue) {
      this._search(this.keywordsValue)
    }
  }

  async search (event) {
    if (event.target.value) {
      this._search(event.target.value)
    }
  }

  async _search (keywords) {
    const articles = search(keywords)
      .filter(article => article.url !== window.location.pathname)
      .slice(0, this.limitValue || undefined)

    if (this.titleValue && !this.hasTitleTarget && articles.length) {
      this.resultsTarget.insertAdjacentHTML("beforebegin", `<h2 data-search-target="title">${this.titleValue}</h2>`)
    }

    this.resultsTarget.innerHTML = ""
    articles.forEach(article => {
      this.resultsTarget.insertAdjacentHTML("beforeend", `
        <a href=${article.url} class="card">
          <h3>${article.title}</h3>
          <p>${article.description} ${this.iconTarget.innerHTML} <span class="date">${article.date}</span></p>
        </a>
      `)
    })
  }
}
